// extracted by mini-css-extract-plugin
module.exports = {"container":"coupon-pill__container___2Nj_B","info":"coupon-pill__info___2Mr-p"};